/**
 * Application Insights custom event names and related telemetry identifiers.
 * Use these symbols at call sites so dashboards and alerts stay aligned with code.
 */
export const TelemetryEvent = {
  SESSION_TRANSITION: 'SessionTransition',
} as const;

export type TelemetryEventName = (typeof TelemetryEvent)[keyof typeof TelemetryEvent];
